import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ACL } from '../../../../constants'
import PushConfirmation from './PushConfirmation'

type SettingsPushConfirmationProps = {
    devicesCount: number
    isOpen: boolean
    storeCount: number
    pushToAllDevices: () => void
    percentage?: number
} 

export default function SettingsPushConfirmation({
    devicesCount,
    isOpen,
    storeCount,
    percentage,
    pushToAllDevices,
}: SettingsPushConfirmationProps) {
    const { t } = useTranslation()

    return (
        <PushConfirmation
            acl={ACL.DEVICE_SETTINGS_PUSH}
            confirmationMessage={t('settings-push-confirmation', {
                context: 'body',
                count: devicesCount,
                stores: storeCount,
            })}
            header={t('settings-push-confirmation', {
                context: 'title',
            })}
            inProgressMessage={t('message-settings-update_body', {
                context: 'other',
                count: devicesCount,
            })}
            percentage={percentage}
            pushToAllDevices={pushToAllDevices}
        >
            <FontAwesomeIcon
                icon="cogs"
                title={t('settings-push-description')}
                style={{ marginLeft: '5px', float: isOpen ? 'right' : 'none' }}
            />
        </PushConfirmation>
    )
}